import DealerAddresses from "./DealerAddresses";
import MapStyles from "./MapStyles"

class DealerMap {
    /**
     * Constructor
     */
    constructor() {
        const translations = $("[data-dealersearch-translations]").data("dealersearch-translations");

        //map reference
        this.map = new google.maps.Map($(DealerMap.mapID).get(0));
        // Bound Reference
        this.bounds = new google.maps.LatLngBounds();
        // marker list
        this.markerList = [];
        // store last location search
        this.lastLocationSearch = null;
        // highlighted marker
        this.currentHighlightedMarker = null;
        // label for "select dealer" button
        this.selectLabel = translations.select;
    }

    /**
     * get the map object
     *
     * @returns {google.maps.Map}
     */
    get(){
        return this.map;
    }

    static get mapID() {
        return '#map'
    }

    static get sidebarID() {
        return '#sidebar'
    }

    /**
     * Print Map
     *
     * @param {[{latitude, longitude, address_index}]} points
     */
    print(points) {

        this.bounds = new google.maps.LatLngBounds();

        if (this.lastLocationSearch) {
            this.bounds.extend(this.lastLocationSearch);
        }

        // clear marker
        this.markerList.forEach(marker => marker.setMap(null));
        this.markerList = [];

        // center of map HQ (points[0]) or first data
        let activeIndex = (points[1] === undefined) ? 0 : 1;

        // Set map options
        this.map.setOptions(
            DealerMap.getMapOptions(
                DealerAddresses.toLatLng(points[activeIndex])
            )
        );

        points.forEach((point, i) => {
           this.addMarker(point, i)
        }, this);

        if (this.markerList.length > 2) {
            this.map.fitBounds(this.bounds);
        } else {
            if (this.map.getZoom() > 10) this.map.setZoom(10);
        }

    }

    /**
     * add marker to map
     *
     * @param {{country, latitude, longitude, address_index, isPremium, isDealerOfTheYear}} point
     * @param {Number} index
     */
    addMarker(point, index) {

        let premium = DealerMap.isPremium(point);
        let type = (premium) ? '--premium' : '';
        let currentIcon = DealerMap.getMarker(type);
        let isHeadQuarter = DealerMap.isHeadQuarter(point);

        let currentLabel = {
            text: index.toString(),
            color: '#000',
            fontSize: "12px"
        };

        let maxBound = (point.country === 'Germany') ? 4 : 20;
        if (index === 0 || isHeadQuarter) { // hq
            currentIcon = DealerMap.getMarker('--brabus');
            currentLabel = null;
        }

        if (index > 0 && index < maxBound) {

            this.bounds.extend(
                DealerAddresses.toLatLng(point)
            );
        }

        let marker = new google.maps.Marker({
            position: {
                lat: parseFloat(point.latitude),
                lng: parseFloat(point.longitude)
            },

            label: currentLabel,
            icon: currentIcon,
            opacity: .8,
            map: this.map
        });

        marker.set('isPremium', premium);
        marker.set('isHQ', isHeadQuarter);
        marker.set('address_index', point.address_index);

        google.maps.event.addListener(marker, 'click', () => {

            let address_index = marker.get('address_index');

            // Show one Sidebar list item
            DealerMap.highlightSidebarItem(address_index);

            // Center map
            //this.map.panTo(marker.getPosition());

            // Highlight marker
            this.highlightMarkerItem(address_index);

            // Trigger reorder event
            $(document).trigger("dealermapcenter.change", ['click']);
        });

        this.markerList.push(marker);


    }

    /**
     * get Marker by id
     *
     * @param {*} address_index
     * @return {google.maps.Marker}
     */
    getMarkerById (address_index){
        return jQuery.grep(this.markerList, (marker) => {
            return (parseInt(marker.get('address_index')) === parseInt(address_index));
        });
    }

    /**
     * highlight marker
     *
     * @param {Number} address_index
     * @param {Number} status
     */
    updateMarkerIcon(address_index = 0, status = 0) {

        let relatedMarker = this.getMarkerById(address_index)[0];

        let type = '';
        if (address_index === 0 || DealerMap.isHeadQuarter(relatedMarker)){ // brabus home
            type = '--brabus';
        } else if (relatedMarker.isPremium) {
            type = '--premium';
        }

        let size, opacity, zIndex;
        if (status === 0){
            size = 1;
            zIndex = 100;
            opacity = .8;
        } else {
            size = 1.2;
            zIndex = 99;
            opacity = 1;
        }

        let iconTemplate = DealerMap.getMarker(type, size);

        relatedMarker.setIcon(iconTemplate);
        relatedMarker.setZIndex(zIndex);
        relatedMarker.setOpacity(opacity);
    }

    /**
     * reset marker
     */
    resetMarkerIcon() {

        if (this.currentHighlightedMarker != null) {
            let marker = this.getMarkerById(this.currentHighlightedMarker)[0];
            let type = this.findType(this.currentHighlightedMarker);
            if (marker !== undefined){
                marker.setZIndex(99);
                marker.setIcon(DealerMap.getMarker(type));
            }
        }
    }

    /**
     *
     * @param address_index
     * @return {string}
     */
    findType(address_index) {
        let relatedMarker = this.getMarkerById(address_index)[0];

        if (address_index === 0 || DealerMap.isHeadQuarter(relatedMarker)){ // brabus home
            return '--brabus';
        } else if (relatedMarker.isPremium) {
            return '--premium';
        }
        return ''
    }

    /**
     * Marker Icon highlight
     *
     * @param {Number} address_index
     */
    highlightMarkerItem(address_index = 0) {
        this.resetMarkerIcon();
        this.updateMarkerIcon(address_index, 1);
        this.currentHighlightedMarker = address_index;
    }

    /**
     * Set center and store last location search
     *
     * @param {google.maps.LatLng} center
     */
    setCenter(center) {
        this.lastLocationSearch = center;
        this.get().setCenter(center);
    }

    /**
     * Update marker label (new order indicator)
     *
     * @param {[{address_index}]} addresses
     */
    updateMarkerLabel(addresses) {
        addresses.forEach((address, index) => {

            let marker = this.getMarkerById(address.address_index)[0];

            if (marker) {
               if (!DealerMap.isHeadQuarter(marker)){
                   marker.setLabel({
                       text:  (index + 1).toString(),
                       color: '#000',
                       fontSize: "12px"
                   });

               }
            }
        });
    }

    /**
     * @return {String} path of resource folder
     */
    static getResourceFolder() {
        let scripts = Array.prototype.slice.call(document.getElementsByTagName('script'));

        for (let i=0; i <= scripts.length; i++){
            let src = scripts[i].src.toString();

            if (src.indexOf('JavaScript') >= 0){
                return src.slice(0, src.indexOf('JavaScript'));
            }
        }
    }

    /**
     * Get default marker
     *
     * @param {String} type
     * @param scale
     * @returns {{fillColor: string, scaledSize: google.maps.Size, size: google.maps.Size, fillOpacity: number, origin: google.maps.Point, anchor: google.maps.Point, strokeWeight: number, labelOrigin: google.maps.Point, strokeColor: string, url: string}}
     */
    static getMarker(type = '', scale = 1){
        return {
            url: DealerMap.getResourceFolder() + '/Images/icons/map-pin' + type + '.svg',
            // This marker is 40 pixels wide by 51 pixels high.
            size: new google.maps.Size(scale* 41, scale * 52),
            scaledSize: new google.maps.Size(scale * 41, scale * 52),
            // The origin for this image is (0, 0).
            origin: new google.maps.Point(0, 0),
            // The anchor for this image is the base of the flagpole at (0, 32).
            anchor: new google.maps.Point(scale * 16.5, scale * 51),
            // origin of label
            labelOrigin: new google.maps.Point(scale * 20, scale * 22),
            fillColor: '#234567',
            fillOpacity: .3,
            strokeColor: 'red',
            strokeWeight: 2,
        };

    }

    /**
     * Get map options
     *
     * @param center
     * @returns {google.maps.MapOptions}
     */
    static getMapOptions(center) {
        return {
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false,
            zoom: 7,
            zoomControl: true,
            streetViewControl: false,
            scaleControl: false,
            styles: MapStyles.get(),
            center: center
        }
    }

     /**
     * Sidebar item renderer
     *
     * @param {{vendor, street, postCode, city, contactPartner,  phone, email, isPremium, isDealerOfTheYear}} address
     * @param index
     * @param modal
     * @returns {string}
     */
     renderItem(address, index, modal) {
          return  `
            <span class="dealer-search-addresses__header">
                ${address.vendor ? '<strong>' + address.vendor + '</strong>' : ''}
                <span class="dealer-search-adresses--categories">
                    ${address.superCar ? '<i class="icon icon-supercars" title="Supercars"></i>' : ''}
                    ${address.tunerCar ? '<i class="icon icon-tuning" title="Tuning"></i>' : ''}
                    ${address.boat ? '<i class="icon icon-boats" title="Boats"></i>' : ''}
                    ${address.isHQ ? '<i class="icon icon-headquarter" title="Headquarter"></i>' : ''}
                </span>
                <br />
                ${address.isPremium ? '<span class="label--premium">Premium Dealer</span><br />' : ''}
                ${address.isDealerOfTheYear ? '<span class="label--dealerOfTheYear">Dealer of the Year</span><br />' : ''}
            </span>
            ${address.contactPartner ? address.contactPartner + '<br />' : ''}
            ${address.street ? address.street + '<br />' : ''}
            ${address.postCode ? address.postCode : ''}
            ${address.city ? address.city + '<br />' : ''}
            ${address.phone ? address.phone + '<br />' : ''}
            ${address.email ? '<a href="mailto:' + address.email + '?bcc=anfragen@brabus.com">' + address.email + '</a><br>' : ''}
            ${modal ? '<span><a id="dealerChoose' + index + '" data-address-identifier="' + address.identifier + '" data-dealer-name="' + address.vendor + '"class="form--button-dark dealerChoose auto">' + this.selectLabel + '</a></span>' : ''}
         `;
     }

    /**
     *
     * @param {{isPremium, isDealerOfTheYear}} address
     * @return {bool}
     */
     static isPremium(address) {
         return (address.isPremium || address.isDealerOfTheYear);
     }

    /**
     *
     * check for HQ
     * @param {{country, latitude, longitude, address_index, isPremium, isDealerOfTheYear, isHQ}} address
     * @return {{isHQ}}
     */
     static isHeadQuarter(address) {
         return (address.isHQ);
     }

    /**
     * Highlight Sidebar Item
     *
     * @param {Number} address_index
     */
    static highlightSidebarItem(address_index) {
        $('#sidebar').addClass('dealer-search--single-item-mode');
        $('[data-address-index]').removeClass('active');
        $('[data-address-index="'+address_index+'"]').addClass('active');
    }


    /**
     * get one sidebar list item
     *
     * @param address
     * @param index
     * @param modal
     * @return {string}
     */
    getSidebarItem(address, index, modal) {
        return "<li class=\"" + (DealerMap.isPremium(address) ? "premium" : "") + (DealerMap.isHeadQuarter(address) ? " headQuarter" : "") +"\" data-address-position=\"" + index + "\" data-address-index=\"" + address.address_index + "\" data-position=\"" + address.position + "\"><p class=\"copy\">" + this.renderItem(address, index, modal) + "</p><i class=\"icon icon-close-small\"></i></li>"
    }

    /**
     * Sidebar
     *
     * @param {[]} addresses
     */
    printSidebar (addresses) {
        let content = "";
        let hq = "";
        let boatOnly = $('[data-boats-only]').length >= 1;
        let modal = $('[data-modal]').length >= 1;
        let currentCountry =  $('#countrySelect').val();

        addresses.forEach((address, index) => {
            if (DealerMap.isHeadQuarter(address)) {

                if (boatOnly) {
                    hq += (currentCountry === 'Finland') ? this.getSidebarItem(address, index, modal) : ""
                } else {
                    hq += this.getSidebarItem(address, index, modal)
                }

            } else {
                content += this.getSidebarItem(address, index, modal)
            }
        });

        if (boatOnly) {
            content = content + hq
        } else {
            content = hq + content
        }

        $(DealerMap.sidebarID).html(content);
    }

    /**
     * rebuild map
     * @param addresses
     */
    render (addresses) {
        this.printSidebar(addresses);
        this.print(addresses);
    }

}

export default DealerMap
